import { SnomedItem } from '../../models/Entities/Snomed/SnomedModels';
import { ErrorType } from '../../models/HttpError';

export const SNOMED_SEARCH_REQUEST = 'SNOMED_SEARCH_REQUEST';
export const SNOMED_SEARCH_SUCCESS = 'SNOMED_SEARCH_SUCCESS';
export const SNOMED_SEARCH_FAILURE = 'SNOMED_SEARCH_FAILURE';
export const SNOMED_SEARCH_CLEAR = 'SNOMED_SEARCH_CLEAR';

export interface SnomedSearchRequestAction {
    type: typeof SNOMED_SEARCH_REQUEST;
    searchTerm: string;
}

export interface SnomedSearchSuccessAction {
    type: typeof SNOMED_SEARCH_SUCCESS;
    payload: SnomedItem[];
    searchTerm: string;
}

export interface SnomedSearchFailureAction {
    type: typeof SNOMED_SEARCH_FAILURE;
    error: ErrorType;
}

export interface SnomedSearchClearAction {
    type: typeof SNOMED_SEARCH_CLEAR;
}
